import { render, staticRenderFns } from "./NotificationBanner.vue?vue&type=template&id=47d09d30&scoped=true&"
import script from "./NotificationBanner.vue?vue&type=script&lang=js&"
export * from "./NotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBanner.vue?vue&type=style&index=0&id=47d09d30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d09d30",
  null
  
)

export default component.exports